import React, { useState } from "react";
import { Button, Grid, TextField, Tooltip } from "@mui/material";
import { useRecordContext, useRefresh } from "react-admin";
import { getCAPQuote } from "../../../../Utils/RestUtils";

const CapFields = () => {
  const record = useRecordContext();
  const refresh = useRefresh();
  const [isLoadingCap, setIsLoadingCap] = useState(false);

  const capHistory = record.leadContact.vehicle.vehicleCapHistory ?? [];
  const vehicleCap = capHistory[capHistory.length - 1] ?? null;

  const tooltipData = vehicleCap
    ? [
        { name: "Average", value: vehicleCap.average },
        { name: "Clean", value: vehicleCap.clean },
        { name: "Retail", value: vehicleCap.retail },
      ]
    : [];

  const handleGetCap = async () => {
    if (isLoadingCap) return;

    setIsLoadingCap(true);

    try {
      await getCAPQuote(record.leadContact.vehicle["@id"]);
      refresh();
    } finally {
      setIsLoadingCap(false);
    }
  };

  return (
    <React.Fragment>
      <Grid
        item
        xs={2}
        sx={{
          "&.MuiGrid-item": {
            paddingTop: "0",
          },
        }}
      >
        <Button disabled={isLoadingCap} onClick={handleGetCap} fullWidth>
          Get Cap
        </Button>
      </Grid>
      <Grid item xs={2}>
        <Tooltip
          title={tooltipData.map((tip) => (
            <div key={tip.name} style={{ fontSize: "12px", padding: "2px" }}>
              <div style={{ width: "60px", display: "inline-block" }}>
                {tip.name}:
              </div>
              <div style={{ display: "inline-block" }}>{tip.value}</div>
            </div>
          ))}
        >
          <TextField
            label="Cap Value"
            disabled
            value={vehicleCap?.value ?? ""}
          />
        </Tooltip>
      </Grid>
    </React.Fragment>
  );
};

export default CapFields;
